<template>
  <selectable-tiles
    ref="selectableTiles"
    v-bind="{ ...$props, ...$attrs }"
    @selection-changed="onChange"
    @hovering-on="(val) => emits('hoveringOn', val)" />
</template>
<script setup lang="ts">
  import { onMounted, ref } from 'vue';

  import SelectableTiles from '@/common/components/controls/SelectableTiles.vue';
  import { LineItem } from '@/common/models';
  import { mapActions } from '@/utils/StateMapping';
  import { ComponentProps } from '@/utils/TypescriptUtils';

  //
  // Props
  //
  type Item = { [key: string]: never } & {
    id: string;
    featureKey?: string | { key: string; transient: boolean };
  };
  // eslint-disable-next-line
  interface SelectableProps extends /* @vue-ignore */ ComponentProps<typeof SelectableTiles> {}
  type Props = SelectableProps & {
    entity: LineItem;
    items: Item[];
    selectedItems?: Item[];
  };
  const props = defineProps<Props>();

  // Emits
  const emits = defineEmits(['selectionChanged', 'hoveringOn']);

  const { updateLineItemAddFeatureKey, updateLineItemRemoveFeatureKey } = mapActions();
  const selectableTiles = ref();
  const lastSelectedItems = ref([]);

  function onChange(items: Item[]) {
    if (props.entity instanceof LineItem) {
      const { entity } = props;
      const removed = lastSelectedItems.value
        .filter((x) => !items.some((y) => y.id === x.id))
        .filter((x) => !!x.featureKey);
      const added = items
        .filter((x) => !lastSelectedItems.value.some((y) => y.id === x.id))
        .filter((x) => !!x.featureKey);
      updateLineItemAddFeatureKey({
        lineItem: entity,
        value: added.map((x) => x.featureKey),
      });
      updateLineItemRemoveFeatureKey({
        lineItem: entity,
        value: removed.map((x) => x.featureKey),
      });
    }
    lastSelectedItems.value = items;
    emits('selectionChanged', items);
  }

  onMounted(() => {
    lastSelectedItems.value = [...selectableTiles.value.selectedItemsInternal];
  });
</script>
